<template>
  <v-card>
    <v-toolbar color="secondary" dark tabs>
      <v-toolbar-title>{{ $tc("design.widget", 2) }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text v-if="Object.keys(widgets).length !== 0">
      <v-list>
        <widgets-manager-item
          v-for="widget in widgets"
          ref="widgetsManagerItems"
          :key="widget.id"
          :widget="widget"
        ></widgets-manager-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import WidgetsManagerItem from './widgetsManager/widgetsManagerItem.vue';

export default {
  components: {
    WidgetsManagerItem,
  },
  computed: {
    widgets: {
      get() {
        return this.$store.getters.getWidgets;
      },
    },
  },
  created() {
    this.$events.$off('deactivate-widgets-manager-items');
    this.$events.$off('set-widgets-manager-active-item');

    this.$events.$on('deactivate-widgets-manager-items', () => {
      if (
        Array.isArray(this.$refs.widgetsManagerItems)
        && this.$refs.widgetsManagerItems.length > 0
      ) {
        this.$refs.widgetsManagerItems.forEach((item) => {
          /* eslint-disable no-param-reassign */
          item.isActive = false;
          /* eslint-enable */
        });
      }
    });

    this.$events.$on('set-widgets-manager-active-item', (payload) => {
      if (this.$refs.widgetsManagerItems !== undefined) {
        this.$refs.widgetsManagerItems.forEach((item) => {
          /* eslint-disable no-param-reassign */
          if (item.widget.id !== payload.id) {
            item.isActive = false;
          } else {
            item.isActive = true;
          }
          /* eslint-enable */
        });
      }
    });
  },
};
</script>

<style scoped>

</style>
